
export default {
	// Internacionalização das mensagens do Vee-validate (http://vee-validate.logaretm.com/localization.html#translation)
	validation: {
		name: 'pt_BR',
		messages: {
			min_value: (e, n) => { return 'O valor mínimo é ' + n[0] + '.'; },
			max_value: (e, n) => { return 'O valor máximo é ' + n[0] + '.'; },
			latitude: () => { return 'Látitude inválida.'; },
			longitude: () => { return 'Longitude inválida.'; },
			required: () => { return 'Campo obrigatório.'; },
			email: () => { return 'Email inválido.'; },
			confirmed: (e, n) => { return 'O campo ' + e + ' não é igual ao ' + n; },
			decimal: 'O campo deve ser um número decimal válido. Ex: 12.32',
			date_format: 'Data inválida ou não está no padrão dia/mês/ano',
			numeroInteiro: () => { return 'O campo deve ser número inteiro. Ex: 232 '; }
		},
		custom: {
			areaHa: {
				max_value: (e, n) => { return 'O limite máximo permitido é ' + n[0] + ' ha.'; }
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/messages.js